import {Component, computed, ElementRef, inject, input, output, ViewChild} from '@angular/core';
import {Popover} from 'primeng/popover';
import {Tooltip} from 'primeng/tooltip';
import {Button} from 'primeng/button';

@Component({
  selector: 'app-popover',
    imports: [
        Popover,
        Tooltip,
        Button
    ],
  templateUrl: './popover.component.html',
  styleUrl: './popover.component.scss'
})
export class PopoverComponent {
    private readonly elementRef = inject(ElementRef<HTMLElement>);

    showCloseIcon = input<boolean>(false);
    class = input<string>('');
    appendTo = input<any>('body');

    onShow = output<any>();

    @ViewChild('popover') popover: Popover;

    protected resolvedAppendTo = computed(() => {
        const value = this.appendTo();
        return value === 'self' ? this.elementRef.nativeElement : value;
    });

    toggle($event: any, target?: any) {
        this.popover.toggle($event, target);
    }

    close($event?: any) {
        this.popover.hide();
    }

    show($event: any, target?: any) {
        this.popover.show($event, target);
    }
}
